import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

const NavbarCSX = ({ trainerID, onSignOut }) => {
	const navigate = useNavigate();

	const handleSignOut = () => {
		if (onSignOut) {
			onSignOut();
			navigate("/");
		}
	};

	return (
		<nav className="navbar navbar-expand-lg navbar-dark bg-dark">
			<NavLink className="navbar-brand mx-3" to="/">
				<img
					src="/images/cw-services.png"
					alt="CW Services Logo"
					style={{
						width: "135px",
						height: "80px",
					}}
				/>
			</NavLink>
			<ul className="navbar-nav ml-auto">
				<li className="nav-item">
					<NavLink className="nav-link" to="/">
						Home
					</NavLink>
				</li>
				<li className="nav-item">
					<NavLink className="nav-link" to="/csx-home">
						CSX Dashboard
					</NavLink>
				</li>
				<li className="nav-item">
					<NavLink className="nav-link" to="/resourcescsx">
						Resources
					</NavLink>
				</li>
			</ul>
			<div className="ml-auto d-flex align-items-center">
				{trainerID ? (
					<>
						<span className="navbar-text text-info mr-4">
							Welcome Back, {trainerID}
						</span>
						<button
							className="btn btn-outline-primary mr-3"
							onClick={handleSignOut}
						>
							Sign Out
						</button>
					</>
				) : (
					<NavLink className="btn btn-outline-primary mr-3" to="/login">
						Sign In
					</NavLink>
				)}
			</div>
		</nav>
	);
};

export default NavbarCSX;
